import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Globe18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_581)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 9.00113V9C0.25 4.16751 4.16751 0.25 9 0.25C13.8325 0.25 17.75 4.16751 17.75 9C17.75 13.8325 13.8325 17.75 9 17.75C4.16788 17.75 0.250611 13.8331 0.25 9.00113ZM5.59418 2.59815C6.60959 2.05682 7.76897 1.75 9 1.75C12.0307 1.75 14.627 3.60959 15.7103 6.25H14C13.2707 6.25 12.5712 6.53973 12.0555 7.05546C11.418 7.69293 11.1667 8.5789 11.284 9.45016C11.3471 10.1944 11.8772 10.6731 12.2843 10.9781C12.7035 11.2923 13.1655 11.5453 13.5788 11.8677C14.4389 12.5385 14.4245 13.3445 13.9553 14.2922C12.659 15.5065 10.9163 16.25 9 16.25C5.8599 16.25 3.18606 14.2537 2.17837 11.461C2.66924 11.6423 3.27003 11.75 4 11.75C4.52744 11.75 5.02461 12.0534 5.5187 12.5813C6.15149 13.2573 6.73096 14.904 7.94892 14.6801C8.39145 14.5987 8.77142 14.2662 8.91102 13.8388C9.35413 12.5736 9.75 11.1211 9.75 9.77001C9.75 8.90471 9.46539 8.23579 8.89253 7.81027C8.3727 7.42415 7.73182 7.33257 7.23242 7.3026C6.74081 7.27311 6.2323 7.32613 5.7436 7.25932C6.23364 6.84438 6.82674 6.53586 7.37544 6.20934C8.25119 5.71625 8.8964 4.70097 8.05453 3.83275C7.43624 3.19511 6.41818 2.84524 5.59418 2.59815ZM3.96745 3.78119C2.66672 5.03577 1.55144 7.13772 1.75159 9.00604C1.8618 10.0347 3.18344 10.25 4 10.25C5.14256 10.25 6.01039 10.9116 6.6138 11.5562C7.0227 11.9931 7.38049 12.5052 7.64445 12.8933C7.96475 11.8701 8.16796 10.8135 8.24986 9.74352C8.24234 9.00879 7.81179 8.84006 7.14258 8.79991C6.20635 8.74373 4.83687 9.0108 4.32918 7.99542C4.02705 7.39115 4.11429 6.76418 4.59366 6.2807C5.24557 5.62319 6.11152 5.30664 6.84395 4.77284C5.99503 4.22208 4.9603 3.90779 3.96745 3.78119ZM15.5945 12.0166C16.0154 11.0981 16.25 10.0765 16.25 9C16.25 8.57374 16.2132 8.15607 16.1426 7.75H14C13.3221 7.75 12.7542 8.31445 12.75 8.99231C12.7717 9.85625 13.9143 10.2271 14.5012 10.6848C14.9106 11.0041 15.3441 11.4277 15.5945 12.0166Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_581'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Globe18.displayName = 'Globe18';
export default Globe18;
